const UY = {
  countryConfig: {
    IBAN: {
      visible: false,
    },
    accountHolderDocNumber: {
      label: "bankDetails.accountHolderDocNumber",
      placeholder: "bankDetails.documentCedulaPlaceholderUy",
      visible: true,
      required: true,
    },
    accountNumber: {
      visible: true,
      required: true,
      label: "bankDetails.accountNumber",
    },
    swift: {
      visible: true,
      required: true,
      label: "bankDetails.swift",
    },
    accountTypeBankDetails: {
      label: "bankDetails.accountTypeBankDetails",
      visible: true,
      required: true,
    },
    bankAddress: {
      visible: false,
      required: false,
    },
  },
};
export { UY };
